import { SleepFormProvider } from "../SleepFormContext";
import { SleepDialogHeader } from "./SleepDialogHeader";
import { SleepDialogFooter } from "./SleepDialogFooter";
import { SleepDialogContent } from "./SleepDialogContent";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { StepType, STEPS } from "../hooks/sleep-dialog-types";
import { EnhancedSleepForm } from "../hooks/useSleepDialogForm";

interface SleepDialogContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  form: EnhancedSleepForm;
  saving: boolean;
  currentStep: StepType;
  showConfirmation: boolean;
  locations: { id: string; description: string }[];
  environments: { id: string; description: string }[];
  onsetMethods: { id: string; description: string }[];
  sounds: { id: string; name: string }[];
  soundLevels: { id: string; level: string }[];
  restfulnessRatings: { id: string; description: string }[];
  selectedChild?: { name: string; id: string };
  handleClose: () => void;
  nextStep: () => void;
  prevStep: () => void;
  onSubmit: (values: any) => void;
  setShowConfirmation: (show: boolean) => void;
}

export function SleepDialogContainer({
  open,
  onOpenChange,
  form,
  saving,
  currentStep,
  showConfirmation,
  locations,
  environments,
  onsetMethods,
  sounds,
  soundLevels,
  restfulnessRatings,
  selectedChild,
  handleClose,
  nextStep,
  prevStep,
  onSubmit,
  setShowConfirmation
}: SleepDialogContainerProps) {
  
  // Handle the Review & Save button click from the footer
  const handleReviewAndSave = () => {
    console.log('📝 [SleepDialogContainer.tsx] Review & Save requested');
    
    if (!showConfirmation) {
      console.log('📝 [SleepDialogContainer.tsx] Opening confirmation dialog');
      setShowConfirmation(true);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto bg-[#1A1F2C] border border-[#333333]/80 shadow-xl">
        <SleepDialogHeader childName={selectedChild?.name} />
        
        <SleepDialogContent
          form={form}
          currentStep={currentStep}
          showConfirmation={showConfirmation}
          locations={locations}
          environments={environments}
          onsetMethods={onsetMethods}
          sounds={sounds}
          soundLevels={soundLevels}
          restfulnessRatings={restfulnessRatings}
          selectedChild={selectedChild}
          nextStep={nextStep}
          prevStep={prevStep}
          setShowConfirmation={setShowConfirmation}
          onSubmit={onSubmit}
        />

        <SleepDialogFooter
          currentStep={currentStep}
          steps={Object.values(STEPS)}
          onBack={prevStep}
          onNext={nextStep}
          onReviewAndSave={handleReviewAndSave}
          form={form}
          saving={saving}
        />
      </DialogContent>
    </Dialog>
  );
}
